// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconSidebar.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconSidebar = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M2.5 1H13.5C14.8807 1 16 2.11929 16 3.5V12.5C16 13.8807 14.8807 15 13.5 15H2.5C1.11929 15 0 13.8807 0 12.5V3.5C0 2.11929 1.11929 1 2.5 1ZM2.5 2.5H5V13.5H2.5C1.94772 13.5 1.5 13.0523 1.5 12.5V3.5C1.5 2.94772 1.94772 2.5 2.5 2.5ZM6.5 2.5H13.5C14.0523 2.5 14.5 2.94772 14.5 3.5V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H6.5V2.5Z" />
  </BaseIcon>
);

export default IconSidebar;
